import { createContext, useContext } from 'react';

export type ThemeAppearance = 'light' | 'dark' | 'system';
export type ThemeAccentColor = 'default' | 'red' | 'green' | 'orange' | 'gray';
export type ThemeRadius = 'none' | 'small' | 'medium' | 'large' | 'full';
export type ThemeScaling = '90%' | '95%' | '100%' | '105%' | '110%';
export type ThemePanelBackground = 'solid' | 'translucent';

export interface Preferences {
	theme: ThemeAppearance;
	reducedMotion: boolean;
	accentColor: ThemeAccentColor;
	radius: ThemeRadius;
	scaling: ThemeScaling;
	panelBackground: ThemePanelBackground;
	transparency: boolean;
}

export interface PreferenceContextValue {
	preferences: Preferences;
	setPreferences: (next: Preferences) => void;
	updatePreferences: (next: Partial<Preferences>) => void;
}

export const defaultPreferences: Preferences = {
	theme: 'dark',
	reducedMotion: false,
	accentColor: 'default',
	radius: 'medium',
	scaling: '100%',
	panelBackground: 'translucent',
	transparency: true
};

export const PreferenceContext = createContext<PreferenceContextValue | undefined>(undefined);

export function usePreferenceContext() {
	const context = useContext(PreferenceContext);
	if (!context) {
		throw new Error('usePreferenceContext must be used within PreferenceProvider');
	}

	return context;
}
